import GuestViewContainer from './containers/GuestViewPageContainer'

export default GuestViewContainer
